import styled from 'styled-components';
import { CustomDialog } from '../../../../../../../components/dialog/v1/CustomDialog';
import CustomBlockButton from '../../../../../../../components/button/CustomBlockButton';
import { useEffect, useState } from 'react';
import { AnalyticsApi } from '../../../../../../../apis/AnalyticsApi';
import { useApiInfoContextValueHook } from '../../../../../../../contexts/ApiInfoContext';
import { SellertoolSignatureUtils } from '../../../../../../../utils/sellertool-signature-utils';
import { CustomBackdropController } from '../../../../../../../components/backdrop/default/v1';
import { CustomDateUtils } from '../../../../../../../utils/CustomDateUtils';
import { FragmentAddPurchaseRecordModal } from './fragments/fragment-add-purchase-record-modal';
import _ from 'lodash';
import { FragmentEditPurchaseRecordModal } from './fragments/fragment-edit-purchase-record-modal';
import { FragmentDeletePurchaseRecordModal } from './fragments/fragment-delete-purchase-record-modal';
import { Link } from 'react-router-dom';
import { FragmentAddPurchaseUrlModal } from './fragments/fragment-add-purchase-url-modal';
import { FragmentEditPurchaseUrlModal } from './fragments/fragment-edit-purchase-url-modal';
import { FragmentDeletePurchaseUrlModal } from './fragments/fragment-delete-purchase-url-modal';

const StyledHeader = styled.div`
    padding: 10px;
`;

const StyledBody = styled.div`
    padding: 10px;

    .flexible{
        display: flex;
        gap: 10px;
    }

    .create-memo-button{
        margin-top: 40px;
        margin-bottom: 40px;
        width: 300px;
        height: 70px;
        font-weight: 700;
        font-size: 18px;
        margin-left: auto;
        margin-right: auto;
        border-radius: 3px;
        background-color: #333;
        color: #fff;
        border: none;
    }

    .content-box{
        flex:1;

        .header{
            display: flex;
            gap: 20px;
            align-items: center;
            margin-bottom: 10px;

            .title{
                font-size: 20px;
                font-weight: 700;
            }
    
            .add-button{
                border-radius: 3px;
                background: #333;
                color:#fff;
                border:none;
                font-weight: 600;
                width: 70px;
                height: 30px;
            }
        }

    }

    .record-list{
        display: flex;
        flex-direction: column;
        gap: 10px;
        height: 400px;
        overflow-y: auto;
        padding: 10px;
        border: 1px solid #e0e0e0;
        border-radius: 3px;
        background: #fff;

        .record-item{
            position:relative;
            border: 1px solid #e0e0e0;
            padding: 10px;
            border-radius: 3px;
            overflow: hidden;
            flex:0 0 auto;

            .content{
                font-size: 16px;
                font-weight: 700;
            }

            .date{
                margin-top: 10px;
                font-size: 10px;
                display: flex;
                gap: 10px;
                justify-content: flex-start;
            }

            .event-buttons{
                margin-top: 10px;
                display: flex;
                gap: 10px;

                button{
                    width: 70px;
                    height: 30px;
                    border-radius: 3px;
                    background: #333;
                    color:#fff;
                    border:none;
                    font-weight: 600;
                    cursor: pointer;

                    &.delete{
                        background: var(--redColor1);
                    }
                }
            }
        }
    }

    .purchase-url-list{
        display: flex;
        flex-direction: column;
        gap: 10px;
        height: 400px;
        overflow-y: auto;
        padding: 10px;
        border: 1px solid #e0e0e0;
        border-radius: 3px;
        background: #fff;
        
        .purchase-url-item{
            position:relative;
            border: 1px solid #e0e0e0;
            padding: 10px;
            border-radius: 3px;
            overflow: hidden;
            flex:0 0 auto;

            .content{
                font-size: 16px;
                font-weight: 700;
            }

            .event-buttons{
                margin-top: 10px;
                display: flex;
                gap: 10px;

                button{
                    width: 70px;
                    height: 30px;
                    border-radius: 3px;
                    background: #333;
                    color:#fff;
                    border:none;
                    font-weight: 600;
                    cursor: pointer;

                    &.url{
                        background: #efefef;
                        color: #333;
                    }

                    &.delete{
                        background: var(--redColor1);
                    }
                }
            }
        }

    }
`;

export function ModalViewMemo({
    open,
    onClose,
    productOptionDetail
}) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();

    const [stockCycleMemo, setStockCycleMemo] = useState(null);

    const [addPurchaseRecordModalOpen, setAddPurchaseRecordModalOpen] = useState(false);
    const [editPurchaseRecordModalOpen, setEditPurchaseRecordModalOpen] = useState(false);
    const [deletePurchaseRecordModalOpen, setDeletePurchaseRecordModalOpen] = useState(false);
    const [targetPurchaseRecord, setTargetPurchaseRecord] = useState(null);


    const [addPurchaseUrlModalOpen, setAddPurchaseUrlModalOpen] = useState(false);
    const [editPurchaseUrlModalOpen, setEditPurchaseUrlModalOpen] = useState(false);
    const [deletePurchaseUrlModalOpen, setDeletePurchaseUrlModalOpen] = useState(false);
    const [targetPurchaseUrl, setTargetPurchaseUrl] = useState(null);

    useEffect(() => {
        if (!apiInfoContextValueHook?.apiInfo?.apiKey || !apiInfoContextValueHook?.apiInfo?.secretKey || !productOptionDetail?.productOptionId) {
            return;
        }
        handleReqFetchStockCycleMemo();
    }, [
        apiInfoContextValueHook?.apiInfo?.apiKey,
        apiInfoContextValueHook?.apiInfo?.secretKey,
        productOptionDetail?.productOptionId,
    ])

    const handleReqFetchStockCycleMemo = async () => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }
        CustomBackdropController().showBackdrop();
        const response = await AnalyticsApi().searchStockCycleMemo({
            headers: headers,
            params: {
                productOptionId: productOptionDetail?.productOptionId
            }
        });

        if (response?.content) {
            setStockCycleMemo(response?.content);
        }
        CustomBackdropController().hideBackdrop();
    }

    const handleReqCreateStockCycleMemo = async () => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }
        CustomBackdropController().showBackdrop();
        const response = await AnalyticsApi().createStockCycleMemo({
            headers: headers,
            body: {
                productOptionId: productOptionDetail?.productOptionId
            }
        });

        if (response?.content) {
            setStockCycleMemo(response?.content);
        }
        CustomBackdropController().hideBackdrop();
    }

    const handleReqUpdateStockCycleMemo = async (newStockCycleMemo, callback) => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        CustomBackdropController().showBackdrop();
        const response = await AnalyticsApi().updateStockCycleMemo({
            headers: headers,
            body: {
                formData: newStockCycleMemo
            }
        });

        if (response?.content) {
            setStockCycleMemo(response?.content);
            callback();
        }
        CustomBackdropController().hideBackdrop();
    }

    const handleAddPurchaseRecord = async (formData) => {
        let newStockCycleMemo = _.cloneDeep(stockCycleMemo);

        newStockCycleMemo.purchaseRecords = [{
            uuid: formData?.uuid,
            memo: formData?.memo,
            createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString(),
        }, ...newStockCycleMemo.purchaseRecords]

        await handleReqUpdateStockCycleMemo(newStockCycleMemo, () => {
            setAddPurchaseRecordModalOpen(false);
        });
    }

    const handleEditPurchaseRecord = async (formData) => {
        let newStockCycleMemo = _.cloneDeep(stockCycleMemo);

        newStockCycleMemo.purchaseRecords = newStockCycleMemo?.purchaseRecords?.map((record) => {
            if (record?.uuid === formData?.uuid) {
                return {
                    ...record,
                    memo: formData?.memo,
                    updatedAt: new Date().toISOString(),
                }
            }
            return record;
        })

        await handleReqUpdateStockCycleMemo(newStockCycleMemo, () => {
            handleEditPurchaseRecordModalClose();
        });
    }

    const handleDeletePurchaseRecord = async (formData) => {
        let newStockCycleMemo = _.cloneDeep(stockCycleMemo);

        newStockCycleMemo.purchaseRecords = newStockCycleMemo?.purchaseRecords?.filter((record) => {
            return record?.uuid !== formData?.uuid;
        })

        await handleReqUpdateStockCycleMemo(newStockCycleMemo, () => {
            handleDeletePurchaseRecordModalClose();
        });
    }

    const handleEditPurchaseRecordModalOpen = (record) => {
        setTargetPurchaseRecord(record);
        setEditPurchaseRecordModalOpen(true);
    }

    const handleEditPurchaseRecordModalClose = () => {
        setTargetPurchaseRecord(null);
        setEditPurchaseRecordModalOpen(false);
    }

    const handleDeletePurchaseRecordModalOpen = (record) => {
        setTargetPurchaseRecord(record);
        setDeletePurchaseRecordModalOpen(true);
    }

    const handleDeletePurchaseRecordModalClose = () => {
        setTargetPurchaseRecord(null);
        setDeletePurchaseRecordModalOpen(false);
    }

    // === Purchase URL ===
    const handleAddPurchaseUrl = async (formData) => {
        let newStockCycleMemo = _.cloneDeep(stockCycleMemo);

        newStockCycleMemo.purchaseUrls = [...newStockCycleMemo.purchaseUrls, {
            uuid: formData?.uuid,
            memo: formData?.memo,
            url: formData?.url,
            createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString(),
        }]

        await handleReqUpdateStockCycleMemo(newStockCycleMemo, () => {
            setAddPurchaseUrlModalOpen(false);
        });
    }

    const handleEditPurchaseUrl = async (formData) => {
        let newStockCycleMemo = _.cloneDeep(stockCycleMemo);

        newStockCycleMemo.purchaseUrls = newStockCycleMemo?.purchaseUrls?.map((purchaseUrl) => {
            if (purchaseUrl?.uuid === formData?.uuid) {
                return {
                    ...purchaseUrl,
                    memo: formData?.memo,
                    url: formData?.url,
                    updatedAt: new Date().toISOString(),
                }
            }
            return purchaseUrl;
        })

        await handleReqUpdateStockCycleMemo(newStockCycleMemo, () => {
            handleEditPurchaseUrlModalClose();
        });
    }

    const handleDeletePurchaseUrl = async (formData) => {
        let newStockCycleMemo = _.cloneDeep(stockCycleMemo);

        newStockCycleMemo.purchaseUrls = newStockCycleMemo?.purchaseUrls?.filter((purchaseUrl) => {
            return purchaseUrl?.uuid !== formData?.uuid;
        })

        await handleReqUpdateStockCycleMemo(newStockCycleMemo, () => {
            handleDeletePurchaseUrlModalClose();
        });
    }

    const handleEditPurchaseUrlModalOpen = (purchaseUrl) => {
        setTargetPurchaseUrl(purchaseUrl);
        setEditPurchaseUrlModalOpen(true);
    }

    const handleEditPurchaseUrlModalClose = () => {
        setTargetPurchaseUrl(null);
        setEditPurchaseUrlModalOpen(false);
    }

    const handleDeletePurchaseUrlModalOpen = (purchaseUrl) => {
        setTargetPurchaseUrl(purchaseUrl);
        setDeletePurchaseUrlModalOpen(true);
    }

    const handleDeletePurchaseUrlModalClose = () => {
        setTargetPurchaseUrl(null);
        setDeletePurchaseUrlModalOpen(false);
    }


    return (
        <>
            <CustomDialog
                open={open}
                onClose={onClose}
                maxWidth='lg'
            >
                <StyledHeader>
                    <CustomDialog.Header>
                        <CustomDialog.Header.Fake />
                        <CustomDialog.Header.Title>메모</CustomDialog.Header.Title>
                        <CustomDialog.Header.Close onClick={onClose} />
                    </CustomDialog.Header>
                </StyledHeader>
                <StyledBody>
                    {!stockCycleMemo ?
                        <CustomBlockButton
                            type='button'
                            className='create-memo-button'
                            onClick={() => handleReqCreateStockCycleMemo()}
                        >
                            메모 시작하기
                        </CustomBlockButton>
                        :
                        <div className='flexible'>
                            <div className='content-box'>
                                <div className='header'>
                                    <div className='title'>구매 기록</div>
                                    <CustomBlockButton
                                        type='button'
                                        className='add-button'
                                        onClick={() => setAddPurchaseRecordModalOpen(true)}
                                    >
                                        추가
                                    </CustomBlockButton>
                                </div>
                                <div className='record-list'>
                                    {stockCycleMemo?.purchaseRecords?.map((record, index) => {
                                        return (
                                            <div className='record-item' key={record?.uuid}>
                                                <div className='content'>{record?.memo}</div>
                                                <div className='date'>
                                                    <div>Updated: {CustomDateUtils().dateToYYYYMMDDhhmmss(record?.updatedAt)}</div>
                                                    <div>Created: {CustomDateUtils().dateToYYYYMMDDhhmmss(record?.createdAt)}</div>
                                                </div>
                                                <div className='event-buttons'>
                                                    <CustomBlockButton
                                                        type='button'
                                                        onClick={() => handleEditPurchaseRecordModalOpen(record)}
                                                    >수정</CustomBlockButton>
                                                    <CustomBlockButton
                                                        type='button'
                                                        className='delete'
                                                        onClick={() => handleDeletePurchaseRecordModalOpen(record)}
                                                    >삭제</CustomBlockButton>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                            <div className='content-box'>
                                <div className='header'>
                                    <div className='title'>구매처 URL</div>
                                    <CustomBlockButton
                                        type='button'
                                        className='add-button'
                                        onClick={() => setAddPurchaseUrlModalOpen(true)}
                                    >
                                        추가
                                    </CustomBlockButton>
                                </div>
                                <div className='purchase-url-list'>
                                    {stockCycleMemo?.purchaseUrls?.map((purchaseUrl, index) => {
                                        return (
                                            <div className='purchase-url-item' key={purchaseUrl?.uuid}>
                                                <div className='content'>{purchaseUrl?.memo}</div>
                                                <div className='event-buttons'>
                                                    <Link to={purchaseUrl?.url} target='_blank'>
                                                        <CustomBlockButton
                                                            type='button'
                                                            className='url'
                                                        >URL</CustomBlockButton>
                                                    </Link>
                                                    <CustomBlockButton
                                                        type='button'
                                                        onClick={() => handleEditPurchaseUrlModalOpen(purchaseUrl)}
                                                    >수정</CustomBlockButton>
                                                    <CustomBlockButton
                                                        type='button'
                                                        className='delete'
                                                        onClick={() => handleDeletePurchaseUrlModalOpen(purchaseUrl)}
                                                    >삭제</CustomBlockButton>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    }
                </StyledBody>
            </CustomDialog>

            {addPurchaseRecordModalOpen &&
                <FragmentAddPurchaseRecordModal
                    open={addPurchaseRecordModalOpen}
                    onClose={() => setAddPurchaseRecordModalOpen(false)}
                    onConfirm={(formData) => handleAddPurchaseRecord(formData)}
                />
            }

            {editPurchaseRecordModalOpen &&
                <FragmentEditPurchaseRecordModal
                    open={editPurchaseRecordModalOpen}
                    onClose={() => handleEditPurchaseRecordModalClose()}
                    purchaseRecord={targetPurchaseRecord}
                    onConfirm={(formData) => handleEditPurchaseRecord(formData)}
                />
            }

            {deletePurchaseRecordModalOpen &&
                <FragmentDeletePurchaseRecordModal
                    open={deletePurchaseRecordModalOpen}
                    onClose={() => handleDeletePurchaseRecordModalClose()}
                    purchaseRecord={targetPurchaseRecord}
                    onConfirm={(formData) => handleDeletePurchaseRecord(formData)}
                />
            }

            {addPurchaseUrlModalOpen &&
                <FragmentAddPurchaseUrlModal
                    open={addPurchaseUrlModalOpen}
                    onClose={() => setAddPurchaseUrlModalOpen(false)}
                    onConfirm={(formData) => handleAddPurchaseUrl(formData)}
                />
            }

            {editPurchaseUrlModalOpen &&
                <FragmentEditPurchaseUrlModal
                    open={editPurchaseUrlModalOpen}
                    onClose={() => handleEditPurchaseUrlModalClose()}
                    purchaseUrl={targetPurchaseUrl}
                    onConfirm={(formData) => handleEditPurchaseUrl(formData)}
                />
            }

            {deletePurchaseUrlModalOpen &&
                <FragmentDeletePurchaseUrlModal
                    open={deletePurchaseUrlModalOpen}
                    onClose={() => handleDeletePurchaseUrlModalClose()}
                    purchaseUrl={targetPurchaseUrl}
                    onConfirm={(formData) => handleDeletePurchaseUrl(formData)}
                />
            }
        </>
    );
}